import React from 'react';
import { BodyText } from "@hm-group/fabric-components/components/Typography";
import { MetaText } from "@hm-group/fabric-components/components/Typography";
import cn from 'classnames';
import "./ProductClubPrice.css";
var styles = { "clubPrice": "dc6998", "hm": "b6eb05", "northstar-small": "f0d589", "northstar-large": "a51fc2" };
const ProductClubPrice = ({ yellowPrice, clubPriceLabel, variant = 'hm' }) => {
    if (!yellowPrice)
        return null;
    const Tag = variant === 'hm' ? BodyText : MetaText;
    return (React.createElement(Tag, { className: cn(styles.clubPrice, styles[variant]), hasEllipsis: true }, `${clubPriceLabel}: ${yellowPrice}`));
};
export default ProductClubPrice;
//# sourceMappingURL=ProductClubPrice.js.map